// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/MatiHero';
import Intro from '../components/MatiIntro';
import Stats from '../components/MatiCEO';
import Footer from '../components/Footer';

function MonowaraActiveTechnical() {
  return (
    <>
      <Intro />
      <Hero />
      <Stats />
      <Footer />
    </>
  );
}

export default MonowaraActiveTechnical;
